import React from 'react';
import HeroSection from '../sections/HeroSection';
import ProductSection from '../sections/ProductSection';
import ValuePropsSection from '../sections/ValuePropsSection';
import PlatformDemoSection from '../sections/PlatformDemoSection';
import SolutionsSection from '../sections/SolutionsSection';
import TeamSection from '../sections/TeamSection';
import PricingSection from '../sections/PricingSection';
import ContactSection from '../sections/ContactSection';
import CTASection from '../sections/CTASection';

const HomePage = () => {
    return (
        <main>
            <HeroSection />
            <ProductSection />
            <PlatformDemoSection />
            <ValuePropsSection />
            <SolutionsSection />

            {/* <ResourcesSection /> */} {/* Will be added sometime by Jon*/}
            <PricingSection />
            <TeamSection />
            <ContactSection />
            <CTASection />
        </main>
    );
};

export default HomePage;
